import { defineTrpcContract, mutation, query } from "@amtana/module";

import {
  acceptInviteInputSchema,
  acceptInviteOutputSchema,
  addMemberInputSchema,
  createOrganizationInputSchema,
  declineInviteInputSchema,
  getOrganizationInputSchema,
  invitationIdInputSchema,
  invitationLinkOutputSchema,
  invitationsInputSchema,
  invitationsOutputSchema,
  inviteMemberInputSchema,
  leaveOrganizationInputSchema,
  membersInputSchema,
  membersOutputSchema,
  membershipSchema,
  myOrganizationsInputSchema,
  myOrganizationsOutputSchema,
  okSchema,
  organizationSchema,
  removeMemberInputSchema,
  renameOrganizationInputSchema,
  restoreOrganizationInputSchema,
  setMemberDisabledInputSchema,
  setMemberRoleInputSchema,
  setOrganizationLogoInputSchema,
} from "./organization.schemas.ts";

// Declared once. The process binds access and handlers; the client derives its hooks.
// `createPersonal`, `membershipsForUser`, `backfillPersonalOrganizations` and (since
// D307) `requestDeletion` are peer-only (auth and the request-scoping seam call the
// first two in-process; the third is an operator's one-time CLI step, D036; the fourth
// is never a customer's own action any more, only auth's own account-deletion cascade,
// S6.10) and carry no tRPC declaration, the same way auth's `admitSsoSignIn` does not.
export const organizationTrpcContract = defineTrpcContract("organization", {
  create: mutation({ input: createOrganizationInputSchema, output: organizationSchema }),
  get: query({ input: getOrganizationInputSchema, output: organizationSchema }),
  rename: mutation({ input: renameOrganizationInputSchema, output: organizationSchema }),
  setLogo: mutation({ input: setOrganizationLogoInputSchema, output: organizationSchema }),
  restoreOrganization: mutation({ input: restoreOrganizationInputSchema, output: organizationSchema }),
  myOrganizations: query({ input: myOrganizationsInputSchema, output: myOrganizationsOutputSchema }),
  addMember: mutation({ input: addMemberInputSchema, output: membershipSchema }),
  setMemberDisabled: mutation({ input: setMemberDisabledInputSchema, output: membershipSchema }),
  // The directory and its three member-management actions (S3.02, S3.03, S4.06).
  members: query({ input: membersInputSchema, output: membersOutputSchema }),
  setMemberRole: mutation({ input: setMemberRoleInputSchema, output: membershipSchema }),
  removeMember: mutation({ input: removeMemberInputSchema, output: okSchema }),
  leave: mutation({ input: leaveOrganizationInputSchema, output: okSchema }),
  // Invitations (S3.04, S3.05, S3.06): the admin side is scoped to the caller's
  // organization the same way member-management is; accept and decline act on
  // whoever is holding the link, named by its token alone.
  inviteMember: mutation({ input: inviteMemberInputSchema, output: invitationLinkOutputSchema }),
  invitations: query({ input: invitationsInputSchema, output: invitationsOutputSchema }),
  resendInvite: mutation({ input: invitationIdInputSchema, output: invitationLinkOutputSchema }),
  copyInviteLink: mutation({ input: invitationIdInputSchema, output: invitationLinkOutputSchema }),
  revokeInvite: mutation({ input: invitationIdInputSchema, output: okSchema }),
  acceptInvite: mutation({ input: acceptInviteInputSchema, output: acceptInviteOutputSchema }),
  declineInvite: mutation({ input: declineInviteInputSchema, output: okSchema }),
});
